// Consent Management

var anySet,
    consentValidity = 365; // Days od consent validity

function getHeight(element) {
    let elementObj = document.getElementById(element);
    return elementObj.offsetHeight;
}

function checkHeight() {
    if (getHeight('consentEnv') < getHeight('consentBox')) {
        let consentBox = document.getElementById('consentBox');
        consentBox.style.cssText = "top: 0; transform: translate(-50%,0);";
    }
}

function setConsent(consentType, consentState) {
    createCookie(consentType, consentState, consentValidity);
}

function setFields() {
    let analyticsStorageField = document.getElementById('analyticsStorage'),
        adStorageField = document.getElementById('adStorage'),
        adPersonalizationField = document.getElementById('adPersonalization'),
        adUserDataField = document.getElementById('adUserData');

    if (readCookie('analytics_storage') == 'granted') {
        analyticsStorageField.checked = true;
        anySet = 1;
    } else if (readCookie('analytics_storage') == 'denied') {
        analyticsStorageField.checked = false;
        anySet = 1;
    }
    if (readCookie('ad_storage') == 'granted') {
        adStorageField.checked = true;
        anySet = 1;
    } else if (readCookie('ad_storage') == 'denied') {
        adStorageField.checked = false;
        anySet = 1;
    }
    if (readCookie('ad_personalization') == 'granted') {
        adPersonalizationField.checked = true;
        anySet = 1;
    } else if (readCookie('ad_personalization') == 'denied') {
        adPersonalizationField.checked = false;
        anySet = 1;
    }
    if (readCookie('ad_user_data') == 'granted') {
        adUserDataField.checked = true;
        anySet = 1;
    } else if (readCookie('ad_user_data') == 'denied') {
        adUserDataField.checked = false;
        anySet = 1;
    }
}

function setVisibility(element, visibility) {
    let elementObj = document.getElementById(element),
        body = document.body;

    if (visibility) {
        elementObj.style.display = "block";
        checkHeight();

        if (element == "consentEnv") {
            body.classList.add("noscroll");
            setFields();

            if (anySet) {
                setVisibility('consentBoxDetailed', 1);
                setVisibility('consentChooseButton', 0);
            }

            const defaultFocusEl = document.getElementById('consent-box__default-focus');
            defaultFocusEl?.focus();

            if (typeof trapFocus === 'function') {
                trapFocus('consentEnv');
            }
        }
    } else {
        elementObj.style.display = "none";

        if (element == "consentEnv") {
            body.classList.remove("noscroll");
            body.style.display = "none"; // FF body height issue fix with rerendering
            body.style.display = "block";

            if (typeof releaseFocus === 'function') {
                releaseFocus('consentEnv');
            }
        }
    }
}

// consentVersion pattern:
//
// First part - major changes that need asking for new consent
// Second part - important changes that could be used for GTM conditioning - Google Sheet detailed record must be made
// Third part - minor changes, no GTM action needed

function generateConsentIdentifier() {
    let consentVersion = document.getElementById("consentVersion");
    if (consentVersion) {
        consentVersion = consentVersion.value;
    } else {
        consentVersion = "0.0.0";
    }

    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const length = 14;
    let consentIdentifier = '';

    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        consentIdentifier += characters[randomIndex];
    }

    consentIdentifier = consentIdentifier + '_' + consentVersion;

    return consentIdentifier;
}

function updateConsentIdentifier() {
    let consentId = readCookie('consentId');

    if (consentId) {
        let [hash, savedVersion] = consentId.split('_');
        if (hash) {
            if (!savedVersion) {
                savedVersion = "2.0.0";
            }
            let consentVersion = document.getElementById("consentVersion");

            if (consentVersion) {
                consentVersion = consentVersion.value;
            } else {
                consentVersion = "0.0.0";
            }

            if (savedVersion && savedVersion != consentVersion) {
                consentId = `${hash}_${consentVersion}`;
                createCookie('consentId', consentId, 365);
                const consentIdElement = document.getElementById('consentId');
                if (consentIdElement) {
                    consentIdElement.textContent = consentId;
                }
            }
        } else {
            eraseCookie('consentId');
            handleConsentId();
        }
    } else {
        handleConsentId();
        // updateConsentIdentifier();
    }
}

function handleConsentId() {
    const consentIdElement = document.getElementById('consentId');

    if (readCookie('consentId')) {
        let consentId = readCookie('consentId');
        if (consentIdElement) {
            consentIdElement.textContent = consentId;
        }

    } else {
        let consentId = generateConsentIdentifier();
        createCookie('consentId', consentId, 365);
        if (consentIdElement) {
            consentIdElement.textContent = consentId;
        }
    }
}


// Event Listeners

function showBoxDetailed() {
    let consentChooseButton = document.getElementById('consentChooseButton');

    consentChooseButton.addEventListener('click', function() {
        setVisibility('consentBoxDetailed', 1);
        setVisibility('consentChooseButton', 0);
    }, {
        once: true
    });
}

function consentAll() {
    let consentAllButton = document.getElementById('consentAllButton');

    consentAllButton.addEventListener('click', function() {
        setConsent("analytics_storage", "granted");
        setConsent("ad_storage", "granted");
        setConsent("ad_personalization", "granted");
        setConsent("ad_user_data", "granted");
        gtag('consent', 'update', {
            'analytics_storage': 'granted',
            'ad_storage': 'granted',
            'ad_personalization': 'granted',
            'ad_user_data': 'granted'
        });
        setVisibility('consentEnv', 0);

        updateConsentIdentifier();

        window.dataLayer.push({
            'event': 'saveConsent',
            'button': 'consentAllButton'
        });
    });
}

function consentNone() {
    let consentNoneButton = document.getElementById('consentNoneButton');

    consentNoneButton.addEventListener('click', function() {
        setConsent("analytics_storage", "denied");
        setConsent("ad_storage", "denied");
        setConsent("ad_personalization", "denied");
        setConsent("ad_user_data", "denied");
        gtag('consent', 'update', {
            'analytics_storage': 'denied',
            'ad_storage': 'denied',
            'ad_personalization': 'denied',
            'ad_user_data': 'denied'
        });
        setVisibility('consentEnv', 0);

        updateConsentIdentifier();

        window.dataLayer.push({
            'event': 'saveConsent',
            'button': 'consentNoneButton'
        });
    });
}

function consentSelected() {
    let consentSelectedButton = document.getElementById('consentSelectedButton'),
        analyticsStorageField = document.getElementById('analyticsStorage'),
        adStorageField = document.getElementById('adStorage'),
        adPersonalizationField = document.getElementById('adPersonalization'),
        adUserDataField = document.getElementById('adUserData');

    consentSelectedButton.addEventListener('click', function() {
        if (analyticsStorageField.checked) {
            setConsent("analytics_storage", "granted");
            gtag('consent', 'update', {
                'analytics_storage': 'granted'
            });
        } else {
            setConsent("analytics_storage", "denied");
            gtag('consent', 'update', {
                'analytics_storage': 'denied'
            });
        }
        if (adStorageField.checked) {
            setConsent("ad_storage", "granted");
            gtag('consent', 'update', {
                'ad_storage': 'granted'
            });
        } else {
            setConsent("ad_storage", "denied");
            gtag('consent', 'update', {
                'ad_storage': 'denied'
            });
        }
        if (adPersonalizationField.checked) {
            setConsent("ad_personalization", "granted");
            gtag('consent', 'update', {
                'ad_personalization': 'granted'
            });
        } else {
            setConsent("ad_personalization", "denied");
            gtag('consent', 'update', {
                'ad_personalization': 'denied'
            });
        }
        if (adUserDataField.checked) {
            setConsent("ad_user_data", "granted");
            gtag('consent', 'update', {
                'ad_user_data': 'granted'
            });
        } else {
            setConsent("ad_user_data", "denied");
            gtag('consent', 'update', {
                'ad_user_data': 'denied'
            });
        }
        setVisibility('consentEnv', 0);

        updateConsentIdentifier();

        window.dataLayer.push({
            'event': 'saveConsent',
            'button': 'consentSelectedButton'
        });
    });
}


// Run it all

function consentManagementRun() {

    // Set Event Listeners
    showBoxDetailed();
    handleConsentId();
    consentAll();
    consentNone();
    consentSelected();
}